import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
/**
 * @author
 * @function LogoutPage
 **/

const Logout = ({ logoutHandler }) => {
  const navigate = useNavigate();
  useEffect(() => {
    logoutHandler();
    navigate("/");
  }, []);
  return <div>Logout</div>;
};

export default Logout;
